import {
  STATUS,
  CRF_NO,
  CREATION_DATE,
  EXPECTED_COMPLETION_DATE,
  DUE_DATE,
  TOTAL_NET_PRICE,
  DEPARTMENT,
  PROJECT,
  ID,
  REQUESTOR,
  REQUEST_TYPE,
  PO_NUMBER,
  RELEASING_CENTER,
  VENDOR,
  DEPARTMENT_APPROVER,
  ACCOUNTING_APPROVER,
  ACCOUNTING_MANAGER,
  PARTICULARS,
  SUB_PROJECT,
  PROJECT_CLASSES
} from 'types'
import headerNames from 'types/tableHeaders'

const headerSetups = {
  [ID]: { field: 'id', headerName: headerNames[ID], width: 70 },
  [CRF_NO]: { field: CRF_NO, headerName: headerNames[CRF_NO], width: 200 },
  [REQUEST_TYPE]: {
    field: REQUEST_TYPE,
    headerName: headerNames[REQUEST_TYPE],
    width: 200
  },
  [REQUESTOR]: {
    field: REQUESTOR,
    headerName: headerNames[REQUESTOR],
    width: 250
  },
  [DEPARTMENT_APPROVER]: {
    field: DEPARTMENT_APPROVER,
    headerName: headerNames[DEPARTMENT_APPROVER],
    width: 250
  },
  [ACCOUNTING_APPROVER]: {
    field: ACCOUNTING_APPROVER,
    headerName: headerNames[ACCOUNTING_APPROVER],
    width: 250
  },
  [ACCOUNTING_MANAGER]: {
    field: ACCOUNTING_MANAGER,
    headerName: headerNames[ACCOUNTING_MANAGER],
    width: 250
  },
  [VENDOR]: {
    field: VENDOR,
    headerName: headerNames[VENDOR],
    width: 250
  },
  [PROJECT]: { field: PROJECT, headerName: headerNames[PROJECT], width: 250 },
  [DEPARTMENT]: {
    field: DEPARTMENT,
    headerName: headerNames[DEPARTMENT],
    width: 250
  },
  [CREATION_DATE]: {
    field: CREATION_DATE,
    headerName: headerNames[CREATION_DATE],
    width: 200
  },
  [EXPECTED_COMPLETION_DATE]: {
    field: EXPECTED_COMPLETION_DATE,
    headerName: headerNames[EXPECTED_COMPLETION_DATE],
    width: 200
  },
  [DUE_DATE]: {
    field: DUE_DATE,
    headerName: headerNames[DUE_DATE],
    width: 200
  },
  [PO_NUMBER]: {
    field: PO_NUMBER,
    headerName: headerNames[PO_NUMBER],
    width: 200
  },
  [TOTAL_NET_PRICE]: {
    field: TOTAL_NET_PRICE,
    headerName: headerNames[TOTAL_NET_PRICE],
    type: 'number',
    width: 200
  },
  [RELEASING_CENTER]: {
    field: RELEASING_CENTER,
    headerName: headerNames[RELEASING_CENTER],
    width: 200
  },
  [VENDOR]: {
    field: VENDOR,
    headerName: headerNames[VENDOR],
    width: 250
  },
  [PARTICULARS]: {
    field: PARTICULARS,
    headerName: headerNames[PARTICULARS],
    width: 250
  },
  [PROJECT]: { field: PROJECT, headerName: headerNames[PROJECT], width: 250 },
  [SUB_PROJECT]: {
    field: SUB_PROJECT,
    headerName: headerNames[SUB_PROJECT],
    width: 250
  },
  [PROJECT_CLASSES]: {
    field: PROJECT_CLASSES,
    headerName: headerNames[PROJECT_CLASSES],
    type: 'number',
    width: 200
  },
  [STATUS]: { field: STATUS, headerName: headerNames[STATUS], width: 200 }
}

export default function (list) {
  const tableColumns = []
  for (const key in headerSetups) {
    if (list.includes(key)) {
      tableColumns.push(headerSetups[key])
    } else {
      tableColumns.push({ ...headerSetups[key], hide: true })
    }
  }
  return tableColumns
}
